import store from "../app/store"

export const getJobCodeData = () => {
  return store.getState().commonConfig.jobCodeData;
}

export const getWorkgroupData = () => {
  return store.getState().commonConfig.workgroupData;
}